"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var transitionStyle = '0.3s height ease-in-out';
var Transition = {
  beforeEnter: function beforeEnter(el) {
    el.style.transition = transitionStyle;
    if (!el.dataset) el.dataset = {};
    el.style.height = 0;
  },
  enter: function enter(el) {
    if (el.scrollHeight !== 0) {
      el.style.height = "".concat(el.scrollHeight, "px");
    } else {
      el.style.height = '';
    }
    el.style.overflow = 'hidden';
  },
  afterEnter: function afterEnter(el) {
    el.style.transition = '';
    el.style.height = '';
  },
  beforeLeave: function beforeLeave(el) {
    if (!el.dataset) el.dataset = {};
    el.style.height = "".concat(el.scrollHeight, "px");
    el.style.overflow = 'hidden';
  },
  leave: function leave(el) {
    if (el.scrollHeight !== 0) {
      el.style.transition = transitionStyle;
      el.style.height = 0;
    }
  },
  afterLeave: function afterLeave(el) {
    el.style.transition = '';
    el.style.height = '';
  }
};
var _default = exports.default = {
  name: 'CollapseTransition',
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children;
    var data = {
      on: Transition
    };
    return h('transition', data, children);
  }
};